// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-header {
  background: var(--ion-white-primary) !important;
}
ion-header ion-toolbar {
  background: var(--ion-white-primary) !important;
}
ion-header ion-toolbar ion-title {
  font-weight: 300;
  font-size: 17px;
  line-height: 25.5px;
}

:host {
  height: 65vh;
  margin-bottom: 2vw;
  background: var(--ion-color-white);
}

.inIcon {
  height: 3vh;
  width: 3vh;
  stroke: var(--ion-text-white);
  stroke-width: 2px;
}

.contentcard {
  box-shadow: none;
}
.contentcard .form-card {
  padding: 2vw 0;
  margin: 0;
  width: 100%;
  background: none;
  border-radius: 0px;
  display: flex;
  background: transparent;
  flex-direction: column;
  align-items: center;
  box-shadow: none;
}
.contentcard .form-card .form-item {
  margin: 1vw 0vw;
  padding: 0;
  display: flex;
  background: transparent;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  width: 90vw;
  box-shadow: none;
}
.contentcard .form-card .form-item ion-label {
  font-size: 10px;
  font-weight: 300;
  letter-spacing: 1px;
  padding: 0 2vw;
  color: var(--ion-black-primary);
}

.form-item-h {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin: 0vw auto;
  padding: 0vw;
  gap: 3vw;
  width: 90vw;
  background: transparent;
  box-shadow: none;
}

.addname {
  width: 40% !important;
}

.number {
  width: 60% !important;
}

.block {
  width: 50% !important;
}

.avenue {
  width: 50% !important;
}

.street {
  width: 70% !important;
}

.bldg {
  width: 30% !important;
}

.flat {
  width: 50% !important;
}

.floor {
  width: 50% !important;
}

.form-footer {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  margin: 0vw auto;
  padding: 3vw 3vw;
  gap: 0;
  background: transparent;
  box-shadow: none;
  position: fixed;
  bottom: 0;
  right: 0;
  height: 6vh;
  z-index: 10;
  border-radius: 20px !important;
  overflow: visible;
}
.form-footer app-button {
  border-radius: 20px !important;
  --border-radius: 20px !important;
  overflow: visible;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/edit-address/edit-address.page.scss"],"names":[],"mappings":"AAAA;EACI,+CAAA;AACJ;AACI;EACI,+CAAA;AACR;AACQ;EACI,gBAAA;EACA,eAAA;EACA,mBAAA;AACZ;;AAIA;EACI,YAAA;EACA,kBAAA;EACA,kCAAA;AADJ;;AAKA;EACI,WAAA;EACA,UAAA;EACA,6BAAA;EACA,iBAAA;AAFJ;;AA6BA;EAEI,gBAAA;AA3BJ;AA+BI;EACI,cAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;AA7BR;AA+BQ;EACI,eAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,uBAAA;EACA,oBAAA;EACA,WAAA;EACA,gBAAA;AA7BZ;AA+BY;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,+BAAA;AA7BhB;;AA2GA;EACI,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,QAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;AAxGJ;;AA2GA;EACI,qBAAA;AAxGJ;;AA2GA;EACI,qBAAA;AAxGJ;;AA2GA;EACI,qBAAA;AAxGJ;;AA2GA;EACI,qBAAA;AAxGJ;;AA2GA;EACI,qBAAA;AAxGJ;;AA2GA;EACI,qBAAA;AAxGJ;;AA2GA;EACI,qBAAA;AAxGJ;;AA2GA;EACI,qBAAA;AAxGJ;;AA0HA;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,MAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,8BAAA;EACA,iBAAA;AAvHJ;AAyHI;EACI,8BAAA;EACA,gCAAA;EAEA,iBAAA;AAxHR","sourcesContent":["ion-header {\n    background: var(--ion-white-primary) !important;\n\n    ion-toolbar {\n        background: var(--ion-white-primary) !important;\n\n        ion-title {\n            font-weight: 300;\n            font-size: 17px;\n            line-height: 25.5px;\n        }\n    }\n}\n\n:host {\n    height: 65vh;\n    margin-bottom: 2vw;\n    background: var(--ion-color-white);\n    // padding-bottom: 2vw;\n}\n\n.inIcon {\n    height: 3vh;\n    width: 3vh;\n    stroke: var(--ion-text-white);\n    stroke-width: 2px;\n}\n\n// .headmodal{\n//         box-shadow: none;\n//     display: flex;\n//     justify-content: flex-start;\n//     align-items: center;\n//     border-radius: 15px;\n//     font-size: 1.2rem;\n//     letter-spacing: 2px;\n//     margin: 2% auto;\n//     padding: 0 2%;\n//     background: var(--ion-color-primary);\n//     color: var(--ion-text-primary);\n//     height: 12vw;\n//     width: 96%;\n// .titlemodal{\n//     width: 100%;\n//     margin: 0 2%;\n// }\n//     .close-button{\n//         --background: var(--ion-text-primary);\n//         height: 60%;\n//     }\n// }\n\n.contentcard {\n    // background: var(--ion-light-grey) !important;\n    box-shadow: none;\n\n    //     overflow: auto;\n    // overflow-x: hidden;\n    .form-card {\n        padding: 2vw 0;\n        margin: 0;\n        width: 100%;\n        background: none;\n        border-radius: 0px;\n        display: flex;\n        background: transparent;\n        flex-direction: column;\n        align-items: center;\n        box-shadow: none;\n\n        .form-item {\n            margin: 1vw 0vw;\n            padding: 0;\n            display: flex;\n            background: transparent;\n            flex-direction: column;\n            justify-content: center;\n            align-items: stretch;\n            width: 90vw;\n            box-shadow: none;\n\n            ion-label {\n                font-size: 10px;\n                font-weight: 300;\n                letter-spacing: 1px;\n                padding: 0 2vw;\n                color: var(--ion-black-primary);\n            }\n\n\n\n            // .form-inner {\n            //     border-radius: 10px;\n            //     text-align: center;\n            //     background: var(--ion-diffuseLight-primary);\n            //     color: var(--ion-black-primary);\n            //     display: flex;\n            //     margin: 0;\n            //     padding: 0;\n            //     height: 8vw;\n            //     font-size: 12px;\n            //     font-weight: 300;\n            //     letter-spacing: 1px;\n            //     padding: 0vw;\n\n\n            //     ion-textarea {\n            //         --background: var(--ion-diffuseLight-primary);\n            //         --padding-start: 16px;\n            //         --padding-end: 16px;\n            //         border: 0px solid var(--ion-diffuseDark-primary);\n            //         border-radius: 10px;\n            //         min-height: 15vh;\n            //     }\n\n            //     ion-input[type=\"hidden\"] {\n            //         display: none;\n            //         border: 0px solid var(--ion-diffuseDark-primary);\n            //         box-shadow: var(--shadow-l1);\n            //     }\n\n            //     ion-input{\n            //         border: 0px solid var(--ion-diffuseDark-primary);\n            //         border-radius: 10px;\n            //         box-shadow: var(--shadow-l1);\n            //     }\n            //     ion-select {\n            //         // line-height: 2.25;\n            //         width: 100% !important;\n            //         text-transform: capitalize;\n            //         // --padding-start: 0;\n            //             line-height: 10vw;\n            //         border: 0px solid var(--ion-diffuseDark-primary);\n            //         border-radius: 10px;\n            //         box-shadow: var(--shadow-l1);\n            //     }\n\n            //     ion-select::part(text) {\n            //         min-height: 25px;\n            //     }\n\n            //     ion-select::part(icon) {\n            //         position: absolute;\n            //         right: 10px;\n            //         opacity: 1;\n            //         color: var(--ion-color-secondary);\n            //     }\n            // }\n        }\n    }\n\n    // ion-button {\n    //     margin: 0vw 5vw 5vw 5vw;\n    //     width: 80vw;\n    //     height: 10vw;\n    //     font-size: 22px;\n    //     --border-radius: 15px;\n    //     border-radius: 15px;\n    //     background: var(--ion-color-primary) !important;\n    //     --background: var(--ion-color-primary) !important;\n    //     --background-activated: var(--ion-color-primary) !important;\n    // }\n}\n\n.form-item-h {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    align-items: center;\n    margin: 0vw auto;\n    padding: 0vw;\n    gap: 3vw;\n    width: 90vw;\n    background: transparent;\n    box-shadow: none;\n}\n\n.addname {\n    width: 40% !important;\n}\n\n.number {\n    width: 60% !important;\n}\n\n.block {\n    width: 50% !important;\n}\n\n.avenue {\n    width: 50% !important;\n}\n\n.street {\n    width: 70% !important;\n}\n\n.bldg {\n    width: 30% !important;\n}\n\n.flat {\n    width: 50% !important;\n}\n\n.floor {\n    width: 50% !important;\n}\n\n// .paci{\n//     width: 40% !important;\n// }\n// .zip{\n//     width: 40% !important;\n// }\n// .dnote{\n//     width: 40% !important;\n// }\n// .note{\n//     width: 40% !important;\n// }\n// .landmark{\n//     width: 40% !important;\n// }\n.form-footer {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n    align-items: center;\n    margin: 0vw auto;\n    padding: 3vw 3vw;\n    gap: 0;\n    background: transparent;\n    box-shadow: none;\n    position: fixed;\n    bottom: 0;\n    right: 0;\n    height: 6vh;\n    z-index: 10;\n    border-radius: 20px !important;\n    overflow: visible;\n\n    app-button {\n        border-radius: 20px !important;\n        --border-radius: 20px !important;\n        // height: 5vh;\n        overflow: visible;\n        // width: 20vw;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
